import React from 'react'
import Mancha from "../../assets/motivacao.svg"
import "./Footer.css"

const Footer = () => {
  return (
    <footer>
        <img src={Mancha} alt="" />
    </footer>
  )
}

export default Footer